import PropTypes from 'prop-types';

/**
 * @deprecated
 * We no longer use enums for props (so that we don't force the user to import the enum).
 * This enum will remain here for backwards compatibility purposes.
 */
var Variants;
(function (Variants) {
    Variants["PRIMARY"] = "primary";
    Variants["SECONDARY"] = "secondary";
    Variants["TERTIARY"] = "tertiary";
})(Variants || (Variants = {}));
var propTypes = {
    variant: PropTypes.oneOf([
        Variants.PRIMARY,
        Variants.SECONDARY,
        Variants.TERTIARY,
    ]),
    styling: PropTypes.oneOf([
        Variants.PRIMARY,
        Variants.SECONDARY,
        Variants.TERTIARY,
    ]),
    onClick: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    block: PropTypes.bool,
    disabled: PropTypes.bool,
    type: PropTypes.string,
    danger: PropTypes.bool,
    v2: PropTypes.bool,
    testId: PropTypes.string,
};
var defaultProps = {
    variant: Variants.PRIMARY,
    block: false,
    disabled: false,
    danger: false,
    v2: false,
};

export { Variants, defaultProps, propTypes };
